var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5,2.25H3.489A3.515,3.515,0,0,0,0,5.783V47.717A3.515,3.515,0,0,0,3.489,51.25H45.5A3.524,3.524,0,0,0,49,47.717V5.783A3.524,3.524,0,0,0,45.5,2.25Zm-30.691,42H7.547V20.866H14.82V44.25ZM11.178,17.672a4.211,4.211,0,1,1,4.211-4.211A4.213,4.213,0,0,1,11.178,17.672ZM42.033,44.25H34.77V32.875c0-2.712-.055-6.2-3.773-6.2-3.784,0-4.364,2.953-4.364,6V44.25H19.37V20.866h6.967v3.194h.1a7.649,7.649,0,0,1,6.88-3.773c7.35,0,8.717,4.845,8.717,11.145Z",
    transform: "translate(0 -2.25)",
    fill: "#13b3f2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.508be5ba4a37173d4efe4a8521fa506c.svg";
export { ForwardRef as ReactComponent };